/** @format */

import React from "react";

const UserTypeContext = React.createContext();

export default UserTypeContext;
